export default __webpack_public_path__ + "static/media/pompe.93e39435.png";